/**
 * DiscoveryFanbasesCard 컴포넌트
 * @description 팬베이스 한 장. 카드는 무엇인지 묻지 않고 얼굴·이름·한 줄만 받는다. 누르면
 *   주소로 가지 않고 시트가 열린다 — 팬베이스 화면은 앱에 있고, 웹은 요약과 "앱에서 보기"
 *   까지다.
 */
import { Avatar } from "@fanwork-web/design-system";
import { memo, useCallback } from "react";

import {
  DISCOVERY_FANBASE_AVATAR_SIZE,
  DISCOVERY_FANBASE_AVATAR_WIDTH,
  discoveryFanbaseStyles,
} from "./DiscoveryFanbases.styles";
import type { DiscoveryFanbasesCardProps } from "./DiscoveryFanbases.types";

import { EXPLORE_COPY } from "../../constants/copy";
import { trackFanbaseCardClicked } from "../../analytics";
import { AppImage, AvatarCard, Reveal, REVEAL_STAGGER } from "@/shared/ui";

const DiscoveryFanbasesCard = memo<DiscoveryFanbasesCardProps>(
  ({ fanbase, onPress, index }) => {
    const open = useCallback(() => {
      trackFanbaseCardClicked(fanbase, index);
      onPress(fanbase.handle);
    }, [fanbase, index, onPress]);

    return (
      <Reveal
        delay={index * REVEAL_STAGGER}
        className={discoveryFanbaseStyles.card}
      >
        <AvatarCard
          avatar={
            fanbase.profileImageUrl ? (
              <Avatar
                type="image"
                size={DISCOVERY_FANBASE_AVATAR_SIZE}
                image={
                  <AppImage
                    uri={fanbase.profileImageUrl}
                    targetWidth={DISCOVERY_FANBASE_AVATAR_WIDTH}
                  />
                }
              />
            ) : (
              <Avatar
                type="initial"
                size={DISCOVERY_FANBASE_AVATAR_SIZE}
                initial={fanbase.name.charAt(0).toUpperCase()}
              />
            )
          }
          name={fanbase.name}
          caption={EXPLORE_COPY.fanbases.memberCount(fanbase.memberCount)}
          onPress={open}
        />
      </Reveal>
    );
  },
);

DiscoveryFanbasesCard.displayName = "DiscoveryFanbasesCard";

export default DiscoveryFanbasesCard;
